import * as sdpTransform from 'sdp-transform'

import { SYNC_TEST } from './constants'

const transformSDP = sdp => {
	const session = sdpTransform.parse(sdp)

	const audio = session.media.find(m => m.type === 'audio')
	if (audio && SYNC_TEST) {
		// ensure stereo audio — must attach to the Opus payload, otherwise sdp-transform writes a malformed `a=fmtp:undefined ...` line and the offer is rejected (no WebRTC connection).
		const opus = audio.rtp?.find(r => r.codec.toLowerCase() === 'opus')
		if (opus) {
			audio.fmtp ??= []
			const fmtp = audio.fmtp.find(f => f.payload === opus.payload)
			if (fmtp) {
				if (!/stereo=1/.test(fmtp.config)) {
					fmtp.config = `${fmtp.config};stereo=1;sprop-stereo=1`
				}
			} else {
				audio.fmtp.push({ payload: opus.payload, config: 'stereo=1;sprop-stereo=1' })
			}
		}
	}

	return sdpTransform.write(session)
}

export default transformSDP
